import { language as lan_functionBar } from "./function-bar";
import { language as lan_createFolderModal } from "./create-folder-modal";
import { language as lan_hintModal } from "./hint-modal";
import { language as lan_moveFileTreeModal } from "./move-file-tree-modal";
import { language as lan_previewModal } from "./preview-modal";
import { language as lan_renameFolderModal } from "./rename-folder-modal";
import { language as lan_setAsClientFilesModal } from "./set-as-client-files-modal";
import { language as lan_setAsShareFilesModal } from "./set-as-share-files-modal";
import { language as lan_uploadResultModal } from "./upload-result-modal";


let language = {
    ...lan_functionBar,
    ...lan_createFolderModal,
    ...lan_hintModal,
    ...lan_moveFileTreeModal,
    ...lan_previewModal,
    ...lan_renameFolderModal,
    ...lan_setAsClientFilesModal,
    ...lan_setAsShareFilesModal,
    ...lan_uploadResultModal,

    FILE_LIBRARY_TOTAL_FILES: "文件总数:",
    FILE_LIBRARY_TOTAL_FOLDERS: "文件夹总数:",
    FILE_LIBRARY_TOTAL_SIZE: "总大小:",

    FILE_LIBRARY_FILE_SELECTED: "选择",

    // 
    FILE_LIBRARY_CREATE_FILE_LIBRARY_BTN: "创建文件库",
    FILE_LIBRARY_SELECT_ALL_BTN: "全选",
    FILE_LIBRARY_MOVE_TO_BTN: "移动到",
    FILE_LIBRARY_DELETE_BTN: "删除",
    FILE_LIBRARY_PREVIEW_BTN: "预览",
    FILE_LIBRARY_OPEN_BTN: "打开",
    FILE_LIBRARY_RENAME_BTN: "重命名",
    FILE_LIBRARY_LOAD_MORE_BTN: "加载更多",
    FILE_LIBRARY_SET_AS_CLIENT_ROOT_FOLDER: "设置为客户端根目录",
    FILE_LIBRARY_SET_AS_SHARE_ROOT_FOLDER: "设置为共享根文件夹",
    FILE_LIBRARY_CREATE_NEW_FOLDER: "创建新文件夹",

    // 
    FILE_LIBRARY_ELEMENT_TYPE: "类型:",
    FILE_LIBRARY_ELEMENT_TYPE_CATALOG: "文件夹",
    FILE_LIBRARY_CLIENT_ROOT_FOLDER: "客户端根目录",
    FILE_LIBRARY_SHARE_ROOT_FOLDER: "共享根目录",

    FILE_LIBRARY_ELEMENT_TOTAL_FOLDERS: "总文件夹:",
    FILE_LIBRARY_ELEMENT_TOTAL_FILES: "总文件:",

    FILE_LIBRARY_ELEMENT_TYPE_IMAGE: "Image/",
    FILE_LIBRARY_IMAGE_SIZE: "大小:",
    FILE_LIBRARY_IMAGE_RESOLUTION: "分辨率:",
    FILE_LIBRARY_FILE_ID: "文件 ID:",

};

export { language }